export default __webpack_public_path__ + "static/media/otros.25438b9e.png";